import { render, staticRenderFns } from "./MixinCUD.vue?vue&type=template&id=e020a280&scoped=true&"
import script from "./MixinCUD.vue?vue&type=script&lang=js&"
export * from "./MixinCUD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e020a280",
  null
  
)

export default component.exports